export default [
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "user" */ '@/views/User/pages/Login')
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import(/* webpackChunkName: "user" */ '@/views/User/pages/Welcome')
  },
  {
    path: '/delete-account',
    name: 'DeleteAccount',
    component: () => import(/* webpackChunkName: "user" */ '@/views/User/pages/DeleteAccount')
  },
    {
    path: '/delete-account-salon-date',
    name: 'DeleteAccountSalonDate',
    component: () => import(/* webpackChunkName: "user" */ '@/views/User/pages/DeleteAccountSalonDate')
  },
]


